import { BehaviorSubject } from 'rxjs';
import { SseData } from '../../models/SseData';
import { createServiceModule, Scopes } from '@aesop-fables/containr';

export const reportGenerationServiceKey = 'services/reportGeneration';

export class ReportGenerationService {
  private readonly regeneratingSubject = new BehaviorSubject<boolean>(false);

  get regenerating$() {
    return this.regeneratingSubject.asObservable();
  }

  async handleStreamStatus(url: string): Promise<void> {
    this.regeneratingSubject.next(true);

    try {
      const eventSource = new EventSource(url, { withCredentials: true });

      return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          this.regeneratingSubject.next(false);
          reject(new Error('timeout'));
        }, 300000);

        eventSource.onmessage = event => {
          const data = JSON.parse(event.data) as SseData;

          if (data.eventType === 'closing' || data.errorMessage) {
            clearTimeout(timeoutId);
            eventSource.close();

            this.regeneratingSubject.next(false);

            if (data.errorMessage) {
              reject(new Error(data.errorMessage));
            } else {
              resolve();
            }
          }
        };

        eventSource.onerror = () => {
          eventSource.close();

          this.regeneratingSubject.next(false);

          reject(new Error('stream error'));
        };
      });
    } catch (error) {
      this.regeneratingSubject.next(false);

      throw error;
    }
  }
}

export const withReportGenerationService = createServiceModule(
  reportGenerationServiceKey,
  services => {
    services.autoResolve<ReportGenerationService>(
      reportGenerationServiceKey,
      ReportGenerationService,
      Scopes.Singleton,
    );
  },
);
